import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-fill-up",
  "use": "icon-fill-up-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-fill-up\">\n<g id=\"icon-fill-up_Direction/fill-up\">\n<path id=\"icon-fill-up_Polygon 2\" d=\"M7.61589 5.46093C7.81579 5.22106 8.18421 5.22106 8.38411 5.46093L12.3166 10.1799C12.588 10.5056 12.3564 11 11.9325 11H8H4.06752C3.6436 11 3.41202 10.5056 3.68341 10.1799L7.61589 5.46093Z\" fill=\"#282C33\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/fill-up.svg
// module id = olAk
// module chunks = 140